<template>
  <el-col class="report-data-overview">
    <googleorsocial :googleorsocial="googleadvertising">
      <div slot="title">{{title}}</div>
      <div slot="bottom-name">相比{{ dataPeriod }}</div>
    </googleorsocial>
  </el-col>
</template>

<script>
import googleorsocial from '@/components/client/googleorsocial/googleorsocial'
export default {
  components: {
    googleorsocial
  },
  props: {
    dataPeriod: {
      type: String
    },
    googleadvertising: {
      type: Object
    },
    title: {
      type: String,
      default: '账户数据总览'
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.report-data-overview {
  background: #fff;
  box-shadow: 0px 2px 6px 0px rgba(233, 236, 248, 1);
  border-radius: 4px;
  padding-bottom: 10px;
}
</style>